import React, {Component} from 'react';
import Container from 'react-bootstrap/Container';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { LinkContainer } from "react-router-bootstrap";
import ReactGA from 'react-ga'
import Mapa from './elementsResultats/Mapa'
import MetaTags from 'react-meta-tags';

class Mapes extends Component {
  
    state = {
    pantalla: 1,
    data1: [{ "nom": "Avià", "color": "#000000" },
    { "nom": "Gironella", "color": "#000000" },
    { "nom": "Puig-reig", "color": "#000000" },
    { "nom": "Cercs", "color": "#000000" },
    { "nom": "Guardiola de Berguedà", "color": "#000000" },
    { "nom": "Olvan", "color": "#000000" },
    { "nom": "Casserres", "color": "#000000" },
    { "nom": "l'Espunyola", "color": "#000000" },
    { "nom": "Montclar", "color": "#000000" },
    { "nom": "Berga", "color": "#000000" }],
    llegenda: []
}

generaData1() { //Genera les dades del partit guanyador
    var dataResposta = [];
    var llegenda = [];
    var partitJaEsLlegenda;

    this.props.municipis.map((municipi) => { //recorrem cada municipi
        var resultatsMunicipi;

        this.props.resultats.forEach(element => { //recorrem els resultats per trobar el del municipi
            if (element.dadesMunicipi.codi === municipi.codi_generalitat) resultatsMunicipi = element.resultatsCandidatures;
        });

        var elementAfegir = { "codi": municipi.codi_ine, "color": "#FFFFFF"} //Valor per defecte

        if (resultatsMunicipi.length>0) {          

            this.props.partits.map((partit) => {
                // console.log(partit.codi_generalitat);
                if (partit.codi_generalitat === resultatsMunicipi[0].codi) {
                    elementAfegir = { "codi": municipi.codi_ine, "color": partit.color}

                    partitJaEsLlegenda = false;

                    llegenda.map(partitLlegenda => { 
                        console.log(partitJaEsLlegenda)
                        if (partitLlegenda.codi === partit.codi_generalitat){
                            partitJaEsLlegenda=true;
                            partitLlegenda.poblesGuanyats++;
                        } 
                    })

                    if (!partitJaEsLlegenda) llegenda.push({ "codi": partit.codi_generalitat,"sigles": partit.sigles, "color": partit.color, "poblesGuanyats":1});
                    
                } 
            })//recorrem els resultats buscant el partit
        }
        
        dataResposta.push(elementAfegir);
    }
    );
    llegenda.sort(this.ordenaTaula);
    this.setState({data1:dataResposta, llegenda});

}

ordenaTaula(a, b) {
    if (a.poblesGuanyats>b.poblesGuanyats) {
      return -1;
    }
    if (a.poblesGuanyats<b.poblesGuanyats) {
      return 1;
    }
    // a debe ser igual b
    return 0;
  }

 componentDidUpdate(prevProps) { //Si es canvia la url que rebem a traves de match, es torna a cridar al backend.
    if (this.props.resultats!==prevProps.resultats) {

    }
  }

  componentDidMount(){ //Si es canvia la url que rebem a traves de match, es torna a cridar al backend.
        ReactGA.pageview(window.location.pathname) //Afegir a cada pàgina que cal comptar
        this.generaData1();
  }


render() {   
    
    if (this.props.resultats&&this.state.pantalla!==2) {
        this.setState({pantalla:2})
    }
    
    return (
        this.state.pantalla===2 && //Només render quan s'han assignat les dades

        <div className="mapes">
                <MetaTags>
                    <title>Mapes - Resultats eleccions al parlament de Catalunya 2021 - Aquí Berguedà</title>
                    <meta name="description" content={"Consulta els mapes amb tots els resultats del Berguedà a les eleccions al Parlament de Catalunya 2021"} />
                    <meta property="og:title" content={"Mapa del Berguedà de les eleccions al Parlament de Catalunya 2021"} />
                </MetaTags> 

          <Container>

            <h5>Mapes electorals</h5>
            <h2>Berguedà</h2>

            {this.props.resultats &&
            <div>
            <h5>La candidatura més votada a cada municipi</h5>
             
            {this.state.llegenda.length>0 && 
             <div className="llegenda">
                 <p>
                     Partits: 

                     {this.state.llegenda.map(partit => 
                        <div className="partit"><span className="quadrat colorCandidatura" style={{backgroundColor: partit.color}}></span>{partit.sigles} ({partit.poblesGuanyats})</div>
                        )}
                 </p>
            </div>}
            
            <Mapa data={this.state.data1}/>  

            <Breadcrumb>
                <LinkContainer to="/resultats/"><Breadcrumb.Item>Resultats poble a poble</Breadcrumb.Item></LinkContainer>
            </Breadcrumb>
        
           </div>}



           </Container>
        </div>
    )
    
}

}

export default Mapes; 